<template>
  <div>
    <div class="parent" :style="style">
      <v-card @click="showMajorDetail">
        <div class="parent-side">
          <v-card-title class="info-title">
            <div class="text-center">
              {{ major.name }}
            </div>
          </v-card-title>
          <div>
            <app-row icon="minus" title="سطح:" :value="major.sath" />
            <app-row icon="minus" title="جنسیت:" :value="major.jensiatString" />
            <app-row
              icon="minus"
              title="واحدعمومی:"
              :value="major.vahedOmoomi"
            />
            <app-row icon="minus" title="واحدتخصصی:" :value="major.vahedTakh" />
          </div>
          <div v-if="showSelectedDetails">
            <v-spacer></v-spacer>
            <v-card
              class="d-flex align-center flex-column"
              style="margin-top: 0; padding-top: 0;"
            >
              <v-card-title>
                توضیحات
              </v-card-title>
              <v-card-subtitle id="textWrap">
                <span>
                  {{ major.description }}
                </span>
              </v-card-subtitle>
            </v-card>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
export default {
  props: ["major", "index", "selectedIndex", "showDetails"],
  components: {
    appRow: DetailRow,
  },
  data: () => ({
    show: false,
  }),
  methods: {
    showMajorDetail() {
      this.$emit("clicked", this.index);
    },
  },
  computed: {
    showSelectedDetails() {
      if (this.showDetails && this.selectedIndex === this.index) {
        return true;
      }
      return false;
    },
    style() {
      var res = "";
      if (this.$store.getters.isMobile) {
        res = "width: 100%";
      } else {
        res = "width: calc(100% - 300px)";
      }
      return res;
    },
  },
  created() {},
};
</script>
<style scoped>
.v-card__title {
  border-radius: 15px 15px 0px 0px !important;
  width: auto;
}

.v-card {
  display: flex !important;
}
.rotated {
  transform-origin: 113px 113px;
  width: 226px;
}
.parent-side {
  border-radius: 15px 15px 0px 15px !important;
  width: 100%;
}
.flex-card {
  display: flex;
  direction: column;
  justify-content: center;
  align-items: center;
}
#textWrap {
  line-break: anywhere;
  text-align: center;
  text-wrap: wrap;
  margin: auto;
}
</style>
